import React from 'react';
import { Routes, Route, useParams } from 'react-router-dom';
import loadable from '@loadable/component';

const Loading = loadable(() => import('components/loading'));

const delayImport =
  (importFunc, ms = 1500) =>
  () =>
    Promise.all([importFunc(), new Promise((res) => setTimeout(res, ms))]).then(
      ([mod]) => mod,
    );

const Loadable = (loader) =>
  loadable(delayImport(loader), {
    fallback: <Loading />,
  });

const BlogPosts = Loadable(() => import('./index'));
const BlogPostBySlug = Loadable(() => import('./BlogPostBySlug'));

const BlogPostBySlugWrapper = () => {
  const { slug } = useParams();
  return <BlogPostBySlug slug={slug} />;
};

const BlogRoutes = () => {
  return (
    <Routes>
      <Route index element={<BlogPosts />} />
      <Route path=":slug" element={<BlogPostBySlugWrapper />} />
    </Routes>
  );
};

export { BlogRoutes };
